import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentAgent } from "../../redux/features/authSlice";
import { useGetDashboardToDoTodayQuery } from "../../redux/api/authApi";
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MaterialReactTable from "material-react-table";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";
import { COLUMNS, TASK_COLUMN } from "./data";
import { isDisabled } from "../../helper/agentRights";
import EditTask from "../Tasks/EditTask";

const LOCAL_STORAGE_KEY = "leads-hidden-columns";

const TodayLeads = () => {
  const [columnVisibility, setColumnVisibility] = useState({});
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "assigned";
  const [activeTab, setActiveTab] = useState(defaultTab);
  const currentAgent = useSelector(selectCurrentAgent);
  const [selectedTask, setSelectedTask] = useState(null);
  const [editOpen, setEditOpen] = useState(false);

  const {
    data: getTodoTodayData,
    isLoading: LeadsLoading,
    refetch,
  } = useGetDashboardToDoTodayQuery({
    today: new Date().toLocaleDateString("en-CA"),
    agtId: currentAgent?.agentid,
  });

  const isMobileScreen = useMediaQuery("(max-width:768px)");

  const handleEditClick = (task) => {
    setSelectedTask(task);
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelectedTask(null);
    refetch();
  };

  let tableData = [];
  if (activeTab === "assigned") {
    const assigned = getTodoTodayData?.assignedLeads;
    tableData = Array.isArray(assigned) ? assigned : assigned ? [assigned] : [];
  } else if (activeTab === "overdue") {
    const overdue = getTodoTodayData?.overdueLeads;
    tableData = Array.isArray(overdue) ? overdue : overdue ? [overdue] : [];
  } else if (activeTab === "followup") {
    const followUp = getTodoTodayData?.followupleads;
    tableData = Array.isArray(followUp) ? followUp : followUp ? [followUp] : [];
  } else if (activeTab === "tasks") {
    const tasks = getTodoTodayData?.tasks;
    tableData = Array.isArray(tasks) ? tasks : tasks ? [tasks] : [];
  }

  let tableColumns = [];
  if (activeTab === "assigned") {
    tableColumns = COLUMNS(refetch);
  } else if (activeTab === "overdue") {
    tableColumns = COLUMNS(refetch);
  } else if (activeTab === "followup") {
    tableColumns = COLUMNS(refetch);
  } else if (activeTab === "tasks") {
    tableColumns = TASK_COLUMN(handleEditClick);
  }

  const agentRights = currentAgent.agentrights || {};
  const canAssignTask = !isDisabled(agentRights, "Assign Task");

  return (
    <>
      {/* Tab Buttons */}
      <StyledTop>
        <Grid item container spacing={2}>
          {["assigned", "overdue", "followup", "tasks"].map((tab) => (
            <Grid item key={tab}>
              <Button
                variant={activeTab === tab ? "contained" : "outlined"}
                onClick={() => setActiveTab(tab)}
              >
                {tab === "assigned"
                  ? "Assigned Today Leads"
                  : tab === "overdue"
                  ? "Overdue Leads"
                  : tab === "followup"
                  ? "Follow-up Leads"
                  : "Tasks"}
              </Button>
            </Grid>
          ))}
        </Grid>
      </StyledTop>

      {/* Table */}
      <div className="relative">
        <MaterialReactTable
          key={activeTab + JSON.stringify(columnVisibility)} // reset on tab change
          enableRowActions={false}
          columns={tableColumns}
          data={tableData}
          getRowId={(row) => row.leadid || row.taskId}
          state={{ showSkeletons: LeadsLoading }}
          initialState={{
            density: "compact",
            columnVisibility,
            pagination: { pageSize: 20 },
          }}
          enablePagination
          enableDensityToggle={false}
          enableStickyHeader={!isMobileScreen}
          muiTableContainerProps={{
            sx: {
              height: "90vh",
              maxHeight: isMobileScreen ? "100%" : "calc(100vh - 320px)",
            },
          }}
          onColumnVisibilityChange={(updater) => {
            const updatedColumnVisibility = updater(columnVisibility);
            localStorage.setItem(
              LOCAL_STORAGE_KEY,
              JSON.stringify(updatedColumnVisibility)
            );
            setColumnVisibility(updatedColumnVisibility);
          }}
        />
      </div>

      {/* Popup for Edit Task */}
      <Dialog open={editOpen} onClose={handleEditClose} maxWidth="sm" fullWidth>
        <EditTask
          canAssignTask={canAssignTask}
          task={selectedTask}
          onClose={handleEditClose}
        />
      </Dialog>
    </>
  );
};

export default TodayLeads;

// Styled Components
const StyledTop = styled("div")(() => ({
  marginTop: "16px",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  rowGap: "20px",
}));
